<template>
  <div>
    <div class="left_div">
      <el-button
        icon="el-icon-arrow-right"
        type="primary"
        size="mini"
        @click="to_router"
      >
        Scratch社区
      </el-button>
    </div>

    <div class="right_div">
      <img src="../assets/stylus/image/head.png" />
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          {{ userInfo.User.Nickname }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="editPassword">修改密码</el-dropdown-item>
          <el-dropdown-item command="logoOut">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <!-- 修改密码弹框 -->
      <el-dialog
        title="修改密码"
        :visible.sync="dialogVisible"
        width="40%"
        :close-on-click-modal="false"
      >
        <el-form :inline="true">
          <el-form-item label="密码">
            <el-input
              type="password"
              show-password
              v-model="password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="dialogVisible = false">取消</el-button>
          <el-button size="mini" type="primary" @click="determine"
            >确定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { logonOut } from "@/api/login.js";
import store from "../store";
import { edit_user_password_api } from "@/api/user.js";

export default {
  computed: {
    ...mapGetters(["userInfo"]),
  },
  data() {
    return {
      dialogVisible: false,
      password: "",
    };
  },

  created() {
    console.log(this.userInfo);
  },

  methods: {
    handleCommand(command) {
      if (command == "logoOut") {
        logonOut().then(() => {
          if (this.$route.query.type == "login_s") {
            this.$router.push({ path: "login_s" });
          } else {
            this.$router.push({ path: "/" });
          }
          window.localStorage.clear();
          window.sessionStorage.clear();
          store.dispatch("user/userInfo", {});
        });
      } else if (command == "editPassword") {
        this.dialogVisible = true;
      }
    },

    //修改密码框确定
    determine() {
      console.log(this.userInfo);
      edit_user_password_api({
        userName: this.userInfo.Name,
        password: this.password,
      }).then(() => {
        this.$message.warning("密码修改成功， 请重新登录!");
        this.$router.push({ path: "/" });
      });
    },

    //跳转
    to_router() {
      this.$router.push({ path: "/edit_home" });
    },
  },
};
</script>

<style lang="stylus" scoped>
 .left_div {
     float: left;
     height:60px;
     position:relative;
     .el-button {
       position: absolute;
       top:50%;
       transform: translate(0%, -50%);
     }
 }

.right_div {
  width: 12%;
  height: 60px;
  float: right;
  position: relative;

  .el-dropdown-link {
    cursor: pointer;
    color: #fff;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }

  img {
    // width: 30%;
    height: 70%;
    position: absolute;
    top: 50%;
	  left:0%;
    transform: translate(0%, -50%);
  }

  .el-dropdown {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0%, -50%);
  }
}
</style>
